export const STARTER_ONE_SEAT_LIMIT_DATE = '2024-01-11';
export const VISITOR_LIMIT_COOLDOWN_DAYS = 30;
